import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import QueryString from 'query-string';

/**
 * Function for making a registration request to the server.
 * This function sends a POST request to the registration endpoint with the provided registration information.
 * @param {object} registrationInformation - The registration information to be sent to the server.
 * @returns {object} An object containing the redirect URL, success status, and authenticated user details.
 */
export default async function registerRequest(registrationInformation) {
  const requestConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    isPublic: true
  };
  const {
    data
  } = await getAuthenticatedHttpClient().post(`${getConfig().LMS_BASE_URL}/api/user/v2/account/registration/`, QueryString.stringify(registrationInformation), requestConfig).catch(e => {
    throw e;
  });
  return {
    redirectUrl: data.redirect_url || `${getConfig().LMS_BASE_URL}/dashboard`,
    success: data.success || false,
    authenticatedUser: data.authenticated_user
  };
}
export async function getFieldsValidations(formPayload) {
  const requestConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    isPublic: true
  };
  const {
    data
  } = await getAuthenticatedHttpClient().post(`${getConfig().LMS_BASE_URL}/api/user/v1/validation/registration`, QueryString.stringify(formPayload), requestConfig).catch(e => {
    throw e;
  });
  return {
    fieldValidations: data
  };
}
//# sourceMappingURL=service.js.map